import Button from '@mui/material/Button'
import { getActionProps } from './actionProps';

export default function PrimaryAction({loadingButton = null, children, sx = {}, ...rest}) {

    const props = {
        ...getActionProps('primaryAction', sx),
        ...rest
    }
    
    return (
        <Button {...props}>{children}</Button>
    )
}
